import { ITennisMatchCard } from "@sky-it-livedata/livedata-sports-design-system";
import { MatchCardData } from "../types";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { CreateMatchCardWidgetInputSchema } from "cdk/graphql";
import { isValidMatchCard } from "./typeguards";


export const transformQuery = (obj: MatchCardData): ITennisMatchCard => {
  if (isValidMatchCard(obj)) {
      CreateMatchCardWidgetInputSchema().parse(obj.data.getMatchCardWidget, {reportInput: true});
      const { updatedAt, createdAt, matchId, tournamentId, competitionId, ...matchCardData } = obj?.data?.getMatchCardWidget!;

      return {
        ...matchCardData
      } as ITennisMatchCard;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in MatchCardQuery object',
      data: obj
    });
  }
};
